import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/unidades`, options).then(response => {
    return {
      list: response.data.data,
      meta: response.data.meta
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/unidades/${id}`, options)
    .then(response => {
      let unidad = jsona.deserialize(response.data);
      delete unidad.links;
      return unidad;
    });
}

function add(unidad) {
  const payload = jsona.serialize({
    stuff: unidad,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/unidades`, payload, options).then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(unidad) {
  const payload = jsona.serialize({
    stuff: unidad,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .patch(`${url}/unidades/${unidad.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function activate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/unidades/activate/${id}`, options);
}

function deactivate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/unidades/deactivate/${id}`, options);
}

function listActive(params) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.get(`${url}/unidades/listActive`, options).then(response => {
    return {
      listActive: jsona.deserialize(response.data),
    };
  });
}

export default {
  list,
  get,
  add,
  update,
  activate,
  deactivate,
  listActive
};
